import { Tv } from 'lucide-react';

export const ChannelBadge = ({ channel }) => {
  return (
    <span 
      className="inline-flex items-center gap-1.5 bg-white/10 backdrop-blur-md px-3 py-1.5 text-xs font-bold uppercase tracking-wider hover:bg-white/20 transition-colors cursor-default"
      data-testid={`channel-badge-${channel.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <Tv className="w-3 h-3" />
      {channel}
    </span>
  );
};

export default ChannelBadge;
